export default __webpack_public_path__ + "static/media/bag-sales.6a3705dc.webp";